import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import DoramaCard from '../components/DoramaCard';
import SkeletonCard from '../components/SkeletonCard';
import TelegramBanner from '../components/TelegramBanner';
import HeroCarousel from '../components/HeroCarousel';
import LeaderboardWidget from '../components/LeaderboardWidget';
import { useGetMaterialsQuery } from '../services/materialsApi';
import styles from '../css/Home.module.css';

const Home = () => {
  const { data: new2026Data, isLoading: isNew2026Loading } = useGetMaterialsQuery({
    year: 2026,
    sort_by: 'imdb_rating',
    per_page: 6,
  });

  const { data: top100Data, isLoading: isTop100Loading } = useGetMaterialsQuery({
    sort_by: 'top100',
    per_page: 6,
    page: 5,
  });

  const new2026 = new2026Data?.data ?? [];
  const top100 = top100Data?.data ?? [];

  return (
    <div className={styles.homePage}>
      <Helmet>
        <title>DoramaHype — дорамы с русской озвучкой онлайн</title>
        <meta name="description" content="Смотрите лучшие корейские дорамы, дорамы 2026, Топ 100 дорам с русской озвучкой бесплатно онлайн на DoramaHype." />
        <meta property="og:title" content="DoramaHype — дорамы с русской озвучкой онлайн" />
        <meta property="og:description" content="Смотрите лучшие корейские дорамы, дорамы 2026, Топ 100 дорам с русской озвучкой бесплатно онлайн на DoramaHype." />
        <meta property="og:url" content="https://doramahype.ru/" />
      </Helmet>
      {/* Hero Carousel */}
      <HeroCarousel />

      {/* Telegram Banner */}
      <TelegramBanner />

      {/* Leaderboard Widget */}
      <LeaderboardWidget
        title="Топ месяца"
        period="current_month"
        discipline="minutes"
        linkTo="/top-users"
      />

      {/* New 2026 Section */}
      <div className={styles.popularSection}>
        <div className={styles.sectionHeader}>
          <h2>Новинки 2026</h2>
          <Link to="/new" className={styles.viewAll}>
            Все
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </Link>
        </div>

        <div className={styles.popularGrid}>
          {isNew2026Loading
            ? Array.from({ length: 6 }, (_, i) => <SkeletonCard key={i} />)
            : new2026.map((item) => (
                <DoramaCard
                  key={item.id}
                  id={item.id}
                  slug={item.slug}
                  slug_id={item.slug_id}
                  image={`https://doramahype.ru/uploads/posters/${item.poster_url}`}
                  title={item.title}
                  rating={item.imdb_rating ?? item.mydramalist_rating ?? item.kinopoisk_rating}
                  year={item.year}
                  genres={item.genres ?? []}
                  status={item.drama_status}
                />
              ))
          }
        </div>
      </div>

      {/* Top 100 Section */}
      <div className={styles.popularSection}>
        <div className={styles.sectionHeader}>
          <h2>Топ 100</h2>
          <Link to="/top-100" className={styles.viewAll}>
            Все
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </Link>
        </div>

        <div className={styles.popularGrid}>
          {isTop100Loading
            ? Array.from({ length: 6 }, (_, i) => <SkeletonCard key={i} />)
            : top100.map((item) => (
                <DoramaCard
                  key={item.id}
                  id={item.id}
                  slug={item.slug}
                  slug_id={item.slug_id}
                  image={`https://doramahype.ru/uploads/posters/${item.poster_url}`}
                  title={item.title}
                  rating={item.imdb_rating ?? item.mydramalist_rating ?? item.kinopoisk_rating}
                  year={item.year}
                  genres={item.genres ?? []}
                  status={item.drama_status}
                />
              ))
          }
        </div>
      </div>
    </div>
  );
};

export default Home;
